if (!customElements.get('fultons-studio-film')) {
  customElements.define('fultons-studio-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.button = this.querySelector('button:not(.fultons-video-toggle)');
      if (!this.querySelector('template') || !this.button) return;
      this.abort = new AbortController();
      const {signal} = this.abort;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)'); this.connection = navigator.connection;
      this.button.hidden = this.canAutoplay();
      this.button.addEventListener('click', () => this.play(true), {signal});
      this.addEventListener('fultons:video-manual', () => { this.manual = true; }, {signal});
      this.sync = () => {
        const hideControl = this.canAutoplay() && !this.blocked;
        if (this.button.hidden !== hideControl) this.button.hidden = hideControl;
        if (!this.eligible() || !this.canAutoplay() && !this.manual) this.pause();
        else if (!this.userPaused && !this.completed && !this.blocked) this.play(false);
      };
      document.addEventListener('visibilitychange', this.sync, {signal});
      this.motion.addEventListener('change', this.sync, {signal}); this.connection?.addEventListener?.('change', this.sync, {signal});
      this.modalObserver = new MutationObserver(this.sync); this.modalObserver.observe(document.body, {subtree:true, attributes:true, attributeFilter:['open','hidden']});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting && entry.intersectionRatio >= .6;
          if (!this.inView) this.completed = false;
          this.sync();
        }, {threshold:[0,.6]});
        this.observer.observe(this);
      }
    }
    canAutoplay() { return !this.motion.matches && !this.connection?.saveData; }
    eligible() { return this.isConnected && this.inView && !document.hidden && !this.closest('[hidden]') && !Array.from(document.querySelectorAll('dialog[open]')).some(dialog => !dialog.contains(this)); }
    pause() { if (this.video && !this.video.paused) { this.automaticPause = true; this.video.pause(); } }
    async play(manual = true) {
      if (!this.eligible() && !manual || !manual && (!this.canAutoplay() || this.userPaused || this.blocked || this.completed)) return;
      if (manual) { this.manual = true; this.userPaused = false; this.blocked = false; this.completed = false; }
      if (!this.video) {
        this.video = this.querySelector('template').content.querySelector('video').cloneNode(true);
        this.video.muted = true; this.video.defaultMuted = true; this.video.controls = false; this.video.playsInline = true; this.video.loop = false;
        const playbackRate = Number(this.dataset.playbackRate) || .8;
        this.video.defaultPlaybackRate = playbackRate; this.video.playbackRate = playbackRate;
        this.video.src = (matchMedia('(max-width: 749px)').matches && this.video.dataset.mobileSrc) || this.video.dataset.desktopSrc;
        this.video.addEventListener('playing', () => {
          this.video.dataset.playing = 'true'; this.userPaused = false; this.blocked = false; this.button.hidden = true;
          if (!this.eligible() && this.observer) this.pause();
        }, {signal:this.abort.signal});
        this.video.addEventListener('pause', () => { if (!this.automaticPause && !this.video.ended) this.userPaused = true; this.automaticPause = false; }, {signal:this.abort.signal});
        this.video.addEventListener('ended', () => { this.completed = true; }, {signal:this.abort.signal});
        this.video.addEventListener('error', () => { this.blocked = true; this.button.hidden = false; }, {signal:this.abort.signal});
        this.insertBefore(this.video, this.button);
        window.FultonsCleanVideo?.mount(this.video);
      }
      if (!this.video.paused || this.pending) return;
      if (this.video.ended) this.video.currentTime = 0;
      this.pending = true;
      try { if (this.video.error) this.video.load(); await this.video.play(); }
      catch(error) { if (error.name !== 'AbortError') { this.blocked = true; this.button.hidden = false; } }
      finally { this.pending = false; if (!this.eligible() && this.observer) this.pause(); }
    }
    disconnectedCallback() {
      this.pause(); this.video?.remove(); this.video = null; this.inView = false;
      this.observer?.disconnect(); this.modalObserver?.disconnect(); this.abort?.abort(); this.abort = null;
    }
  });
}
